export const createApiUrl = endpoint => {
  const isProd = process.env.NODE_ENV === 'production';
  const api =
    isProd || true
      ? 'https://xwing-data-crowdsource.herokuapp.com/api'
      : 'http://localhost:8080/api';
  return `${api}${endpoint}`;
};

const get = async endpoint => {
  const response = await fetch(createApiUrl(endpoint));
  return await response.json();
};

const put = async (endpoint, id, data) => {
  const response = await fetch(createApiUrl(endpoint), {
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify(data),
    method: 'PUT',
    mode: 'cors',
  });
  return await response.json();
};

const getRandomItemFromList = items => {
  return items[Math.floor(Math.random() * items.length)];
};

export const getAllPilots = async () => await get('/pilots');
export const getPilot = async id => await get(`/pilots/${id}`);
export const updatePilot = async (id, data) => await put(`/pilots/${id}`, id, data);
export const getIncompletePilot = async (filteredIds = []) => {
  const items = await getAllPilots();
  const incomplete = items.filter(
    item => filteredIds.indexOf(item._id) === -1 && isIncompletePilot(item)
  );
  return getRandomItemFromList(incomplete.length ? incomplete : items);
};

export const getAllUpgrades = async () => await get('/upgrades');
export const getUpgrade = async id => await get(`/upgrades/${id}`);
export const updateUpgrade = async (id, data) => await put(`/upgrades/${id}`, id, data);
export const getIncompleteUpgrade = async (filteredIds = []) => {
  const items = await getAllUpgrades();
  const incomplete = items.filter(
    item => filteredIds.indexOf(item._id) === -1 && isIncompleteUpgrade(item)
  );
  return getRandomItemFromList(incomplete.length ? incomplete : items);
};

export const getAllShips = async () => await get('/ships');
export const getShip = async id => await get(`/ships/${id}`);
export const updateShip = async (id, data) => await put(`/ships/${id}`, id, data);
export const getIncompleteShip = async (filteredIds = []) => {
  const items = await getAllShips();
  const incomplete = items.filter(
    item => filteredIds.indexOf(item._id) === -1 && isIncompleteShip(item)
  );
  return getRandomItemFromList(incomplete.length ? incomplete : items);
};

export const isIncompleteShip = item => {
  return !item.name || !item.size || !('agility' in item) || !('hull' in item);
};

export const isIncompleteUpgrade = item => {
  return !item.name || !item.text;
};

export const isIncompletePilot = item => {
  return !item.name || !item.ship || (!item.ability && !item.text);
};



// WEBPACK FOOTER //
// ./src/api.js